module.exports = __webpack_public_path__ + "static/img/monitiornew1.d25c5d92.png";